import { render, staticRenderFns } from "./CustomStar.vue?vue&type=template&id=02e710a8&scoped=true&"
import script from "./CustomStar.vue?vue&type=script&lang=js&"
export * from "./CustomStar.vue?vue&type=script&lang=js&"
import style0 from "./CustomStar.vue?vue&type=style&index=0&id=02e710a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e710a8",
  null
  
)

export default component.exports